import { loadedAnalytics } from "./loadAnalyticsBrowser";
import Store from "~/common/Store";
import MarketingEventHelpers from "../MarketingHelpers/MarketingEventHelpers";
import { getHashedCustomerEmail } from "~/userAnalytics";

export const sendCustomerIoNewsletterSignupEvent = (email: string) => {
  if (!loadedAnalytics) return;
  const { user } = Store.getState();
  loadedAnalytics.track("newsletter_signup", {
    event_timestamp: MarketingEventHelpers.getCurrentTimeStamp(),
    internal_user_index: user?.analyticsData.uq_customer_id ?? "",
    is_internal: user.analyticsData.is_internal,
    hashedUserEmailSha256: getHashedCustomerEmail(email),
    internal_logged_in_as_user: user.analyticsData?.logged_in_as_user,
    newsletter_email: email.toLowerCase(),
  });
};

export const getCheckedStatusAndSendNewsLetterEvent = (email: string) => {
  const newsLetterCheckbox = document.getElementById("receive_specials");
  if (newsLetterCheckbox) {
    const { checked } = newsLetterCheckbox as HTMLInputElement;
    if (checked) {
      if (email) {
        sendCustomerIoNewsletterSignupEvent(email);
      }
    }
  }
};
